import React from 'react';
import Modal from '../Modal';
import FormInput from '../FormInput';

const EtudiantEditModal = ({
  isOpen,
  onClose,
  etudiant,
  onSubmit
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(etudiant);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Modifier l'étudiant"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <FormInput
          label="Nom"
          name="nom"
          value={etudiant?.nom || ''}
          onChange={(e) => {
            if (etudiant) {
              etudiant.nom = e.target.value;
            }
          }}
          required
        />
        
        <FormInput
          label="Prénom"
          name="prenom"
          value={etudiant?.prenom || ''}
          onChange={(e) => {
            if (etudiant) {
              etudiant.prenom = e.target.value;
            }
          }}
          required
        />
        
        <FormInput
          label="Email"
          name="email"
          type="email"
          value={etudiant?.email || ''}
          onChange={(e) => {
            if (etudiant) {
              etudiant.email = e.target.value;
            }
          }}
        />
        
        <FormInput
          label="Contact"
          name="contact"
          value={etudiant?.contact || ''}
          onChange={(e) => {
            if (etudiant) {
              etudiant.contact = e.target.value;
            }
          }}
        />
        
        <FormInput
          label="Adresse"
          name="adresse"
          value={etudiant?.adresse || ''}
          onChange={(e) => {
            if (etudiant) {
              etudiant.adresse = e.target.value;
            }
          }}
        />
        
        <div className="flex justify-end space-x-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Annuler
          </button>
          <button
            type="submit"
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700"
          >
            Modifier
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default EtudiantEditModal;
